import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import ArrowLeftTailed from "../../assets/icons/arrows/left-tailed";
import Footer from "../../components/main/Footer";
import Header from "../../components/main/Header";
import { useAppSelector } from "../../store/hook";
import { trackPageView } from "../../utils/analytics";

import "./Root.css";

const Root = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isHome = pathname === "/";
  const { user } = useAppSelector((state) => state.auth);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  // Track route changes
  useEffect(() => {
    const trackPage = async () => {
      await trackPageView(pathname, undefined, user);
    };
    trackPage();
  }, [pathname, user]);

  return (
    <Box id="main">
      <Header />
      <div id="content" className={!isHome ? "content" : ""}>
        {!isHome && isSmallScreen && (
          <div className="go-back-arrow" onClick={() => navigate(-1)}>
            <ArrowLeftTailed color="black" />
          </div>
        )}
        <Outlet />
      </div>
      <Footer />
    </Box>
  );
};

export default Root;
